module.exports = __webpack_public_path__ + "img/grain2.fc0d300a.png";